/**
 * @desc: 差错处理
 * @created: 2020/6/19
 * @author: huli
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/mistake/list', params)
}


export const getDetails = params => {
  return request.get(' /mistake/details', params)
}

// 查询差错处理经纬度
export const getSelectCoordinatr = params => {
  return request.get('/mistake/selectCoordinate', params)
}


// 一件勾兑
export const getBlend = params => {
  return request.get('/mistake/blend', params)
}

